import { render, staticRenderFns } from "./ShowApiLogs.vue?vue&type=template&id=06b92298&scoped=true"
import script from "./ShowApiLogs.vue?vue&type=script&lang=js"
export * from "./ShowApiLogs.vue?vue&type=script&lang=js"
import style0 from "./ShowApiLogs.vue?vue&type=style&index=0&id=06b92298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b92298",
  null
  
)

export default component.exports